import React, { useState } from 'react';
import { auth } from '../lib/firebase';
import { updatePassword } from 'firebase/auth';
import { Lock, User, Menu } from 'lucide-react';
import { Sidebar } from '../components/Sidebar';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardHeader, CardContent } from '../components/ui/card';
import { Separator } from '../components/ui/separator';
import { toast } from 'react-hot-toast';

export function Profile() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(true);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (newPassword.length < 6) {
        throw new Error('A senha deve ter pelo menos 6 caracteres');
      }

      if (newPassword !== confirmPassword) {
        throw new Error('As senhas não coincidem');
      }

      const user = auth.currentUser;
      if (!user) {
        throw new Error('Usuário não autenticado');
      }

      await updatePassword(user, newPassword);
      
      toast.success('Senha atualizada com sucesso');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      console.error('Erro ao atualizar senha:', err);
      toast.error(err instanceof Error ? err.message : 'Erro ao atualizar senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar
        user={auth.currentUser}
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
      />

      <Button
        variant="ghost"
        size="icon"
        onClick={() => setMenuOpen(true)}
        className={`fixed top-4 left-4 z-20 ${menuOpen ? 'hidden' : 'block'}`}
      >
        <Menu className="w-6 h-6" />
      </Button>

      <div className={`flex-1 transition-all duration-200 ${menuOpen ? 'ml-64' : 'ml-0'}`}>
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="flex items-center gap-3 mb-8">
            <User className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-bold">Perfil</h1>
          </div>

          <Card>
            <CardHeader>
              <div className="mb-6">
                <h2 className="text-xl font-semibold">Informações do Usuário</h2>
                <p className="text-muted-foreground">
                  Email: {auth.currentUser?.email}
                </p>
              </div>
            </CardHeader>

            <Separator />

            <CardContent className="pt-6">
              <div>
                <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                  <Lock className="w-5 h-5" />
                  Alterar Senha
                </h2>

                <form onSubmit={handleSubmit} className="max-w-md space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="newPassword">Nova Senha</Label>
                    <Input
                      id="newPassword"
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Digite a nova senha"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="confirmPassword">Confirmar Nova Senha</Label>
                    <Input
                      id="confirmPassword"
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirme a nova senha"
                      required
                    />
                  </div>

                  <Button
                    type="submit"
                    disabled={loading}
                    className="w-full"
                  >
                    {loading ? 'Atualizando...' : 'Atualizar Senha'}
                  </Button>
                </form>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}